const registerEN = {
	title: "Register",
	email: "Email",
	password: "Password",
	firstName: "First name",
	lastName: "Last name",
	submit: "Register",
	loading: "Registering...",
	error: "Could not register user",
	haveAccount: "Already have an account?",
	signIn: "Sign in",
	acceptTerms: "I agree to the",
	termsLink: "Terms & Conditions",
	mustAcceptTerms: "You must accept the Terms & Conditions to continue.",
};

export default registerEN;
